import NavItem from '@components/Common/NavItem';

import styles from './style.module.css';
import {ComponentWithChildrenProps} from '@interfaces/component';
import Link from '@components/Common/Link';

export function ProductTabNavItem({
  isActive,
  children,
  setActiveTab,
}: ComponentWithChildrenProps & {
  isActive: boolean;
  setActiveTab: () => void;
}) {
  return (
    <NavItem
      onClick={setActiveTab}
      classNames={`${isActive && styles.activeTab}`}
    >
      <Link variant={'buttonLink'}>{children}</Link>
    </NavItem>
  );
}
